import { carrierHasLogo } from "@/components/common/CarrierLogo";

export type ChartCarrierLegend = "series" | "category";

/** Map KPI label/group dimensions to chart legend logo placement. */
export function carrierLegendForDimensions(
  labelDim: string | null,
  groupDim: string | null,
): ChartCarrierLegend | undefined {
  if (groupDim === "carrier") return "series";
  if (labelDim === "carrier") return "category";
  return undefined;
}

const NON_CARRIER_LABELS = new Set(["", "other", "unknown", "—", "-"]);

/** Raw carrier / SCAC for a legend row when the chart is carrier-scoped. */
export function carrierCodeForLegendEntry(
  mode: ChartCarrierLegend | undefined,
  placement: ChartCarrierLegend,
  rawKey: string | undefined,
  displayLabel: string,
): string | undefined {
  if (mode !== placement) return undefined;
  const code = (rawKey ?? displayLabel).trim();
  if (NON_CARRIER_LABELS.has(code.toLowerCase())) return undefined;
  if (!carrierHasLogo(code)) return undefined;
  return code;
}
